export default "__VITE_ASSET__e208c386__"